<script>
import baseMixin from '@/mixins/baseMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ServiceStatusDialog',
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      serviceStatus: 'serviceStatus',
    }),
  },
  async created() {
    await this.fetchServiceStatus()

    // Inject status html into body content
    document
      .getElementById('service-status-dialog__body-content')
      .insertAdjacentHTML('afterbegin', this.serviceStatus.html)
  },
  methods: {
    ...mapActions({
      fetchServiceStatus: 'fetchServiceStatus',
    }),
  },
}
</script>

<template>
  <v-card v-if="serviceStatus" tile>
    <v-toolbar dark flat>
      <v-btn icon dark @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title
        :class="[isMobileViewPort ? 'body-2' : 'font-weight-bold']"
      >
        {{ serviceStatus.bannerTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <v-list-item :class="isMobileViewPort ? 'pl-0 ml-0' : ''">
          <v-list-item-content>
            <v-list-item-subtitle>Severity</v-list-item-subtitle>
            <v-list-item-title>
              <BaseStatusLabel :text="serviceStatus.severity" icon />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :class="isMobileViewPort ? 'pl-0 ml-0' : ''">
          <v-list-item-content>
            <v-list-item-subtitle>Region</v-list-item-subtitle>
            <v-list-item-title>
              {{ serviceStatus.region }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div
        id="service-status-dialog__body-content"
        :class="isMobileViewPort ? '' : 'mx-4'"
      ></div>
    </v-card-text>
  </v-card>
</template>
